import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const fetchClientProviderConfig = async ({ rootGetters, commit }, clientSid) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = await stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getClientProviderConfig(clientSid);
  if (response.data) {
    commit('setClientProvider', response.data);
  }
  return response;
};
